module.exports = __webpack_public_path__ + "img/m-banner-ugevkzdv-ja-JP.009af81f.jpg";